import React, { useState } from 'react';
import { Package, Plus, Edit2, Trash2, Search } from 'lucide-react';
import Button from '../../components/ui/Button';
import { formatMoney } from '../../utils/formatters';
import './InventoryPage.css';

const InventoryPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [products] = useState([
    { id: 1, name: 'Coca Cola 6010ml', barcode: '123456789', price: 15.50, stock: 25, category: 'Bebidas' },
    { id: 2, name: 'Pan Bimbo Grande', barcode: '987654321', price: 32.00, stock: 12, category: 'Panadería' },
    { id: 3, name: 'Leche Lala 1L', barcode: '456789123', price: 24.50, stock: 8, category: 'Lácteos' },
    { id: 4, name: 'Huevos San Juan 12pz', barcode: '789123456', price: 45.00, stock: 15, category: 'Huevos' },
    { id: 5, name: 'Aceite Capullo 1L', barcode: '321654987', price: 35.00, stock: 6, category: 'Aceites' },
  ]);

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.barcode.includes(searchTerm) ||
    product.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getStockStatus = (stock) => {
    if (stock <= 5) return 'low';
    if (stock <= 10) return 'medium';
    return 'high';
  };

  return (
    <div className="inventory-page">
      <div className="inventory-header">
        <div className="header-left">
          <Package size={24} />
          <h2>Gestión de Inventario</h2>
        </div>
        <Button icon={<Plus size={20} />}>
          Agregar Producto
        </Button>
      </div>

      <div className="inventory-filters">
        <div className="search-container">
          <Search size={20} className="search-icon" />
          <input
            type="text"
            placeholder="Buscar por nombre, código de barras o categoría..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      <div className="inventory-content">
        <div className="stats-grid">
          <div className="stat-card">
            <h3>Total Productos</h3>
            <p className="stat-number">{products.length}</p>
          </div>
          <div className="stat-card">
            <h3>Stock Bajo</h3>
            <p className="stat-number danger">
              {products.filter(p => p.stock <= 5).length}
            </p>
          </div>
          <div className="stat-card">
            <h3>Valor Total</h3>
            <p className="stat-number">
              {formatMoney(products.reduce((sum, p) => sum + (p.price * p.stock), 0))}
            </p>
          </div>
        </div>

        <div className="products-table-container">
          <table className="products-table">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Código</th>
                <th>Categoría</th>
                <th data-type="numeric">Precio</th>
                <th data-type="numeric">Stock</th>
                <th data-type="numeric">Total</th>
                <th data-type="actions">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.map(product => (
                <tr key={product.id}>
                  <td className="product-name">{product.name}</td>
                  <td className="barcode">{product.barcode}</td>
                  <td>
                    <span className="category-badge">{product.category}</span>
                  </td>
                  <td className="price">{formatMoney(product.price)}</td>
                  <td>
                    <span className={`stock-badge ${getStockStatus(product.stock)}`}>
                      {product.stock}
                    </span>
                  </td>
                  <td className="total">{formatMoney(product.price * product.stock)}</td>
                  <td className="actions">
                    <button className="action-btn edit">
                      <Edit2 size={16} />
                    </button>
                    <button className="action-btn delete">
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InventoryPage;